import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTE } from 'constants/route';
import './styles.css';

const JobCredits = props => {
  const { creditsCount = 0 } = props;
  return (
    <div className="job-credits">
      <h4 className="job-credits__title">
        <div className="job-credits__number">{creditsCount}</div>
        Job Credits
      </h4>

      <Link
        className="job-credits__link"
        to={{
          pathname: ROUTE.RECRUITER_PURCHASE,
          state: { returnUrl: window.location.pathname },
        }}
      >
        Purchase More Credits
      </Link>
    </div>
  );
};

export default JobCredits;
